import { render, staticRenderFns } from "./need.vue?vue&type=template&id=ed762d58&"
import script from "./need.vue?vue&type=script&lang=js&"
export * from "./need.vue?vue&type=script&lang=js&"
import style0 from "./need.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports